var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: { select: _vm.modelChange }
        },
        [
          _c("el-menu-item", { attrs: { index: "tokenMg" } }, [
            _vm._v("TOKEN管理")
          ]),
          _c("el-menu-item", { attrs: { index: "accountMg" } }, [
            _vm._v("账号管理")
          ])
        ],
        1
      ),
      _c("accountMg", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "accountMg",
            expression: "activeIndex == 'accountMg'"
          }
        ],
        ref: "accountMg"
      }),
      _c("tokenMg", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "tokenMg",
            expression: "activeIndex == 'tokenMg'"
          }
        ],
        ref: "tokenMg"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }